export default {
  dataBaseUrl: "https://raw.githubusercontent.com/crazy-guys/aflow-data/master/"
  // dataBaseUrl: "/data/"
};
